import { icon } from "../icons.js";
import { esc } from "./html.js";
import { isStale } from "../lib/avail.js";

// Плашки состояния данных: фатальная ошибка, пустая карта, устаревший скан (>30 мин)
export function renderNotice(state) {
  if (state.error) {
    return `<div class="okb-notice okb-error">${icon("warn")}<span>${esc(state.error)}</span></div>`;
  }
  if (!state.map) return "";
  if (state.map.byDate.size === 0) {
    const dev = /^(localhost|127\.0\.0\.1)$/.test(location.hostname)
      ? " Для разработки: наполните кэш командой npm run scan:once."
      : "";
    return `<div class="okb-notice okb-error">${icon("warn")}<span>Данных о наличии пока нет — попробуйте зайти позже.${esc(dev)}</span></div>`;
  }
  if (isStale(state.map.age)) {
    const min = state.map.age?.seconds != null ? Math.round(state.map.age.seconds / 60) : null;
    return `<div class="okb-notice okb-stale">${icon("clock")}<span>Данные о наличии обновлялись ${
      min != null ? `${min} мин назад` : "давно"
    } — цены и доступность могут отличаться.</span></div>`;
  }
  return "";
}
